export default "__VITE_ASSET__kfecJF0t__"